"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M2.99948819 5.967157v7",
  stroke: "#736F7F",
  strokeLinecap: "square"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M2.99598101.7852099c-.18612246-.0008419-.35831029.0984972-.45074599.2600458L.07306659 5.33774445c-.09742212.15967721-.09742212.36041432 0 .52009153.09189617.16208507.2644291.2616233.450746.26008229h4.95473868c.18587038.00008269.35767586-.0989991.45066267-.25993781.09298681-.1609387.09301857-.35926753.00008333-.52023601L3.45019429 1.0452557C3.35714944.8826197 3.18334.7831105 2.99598101.7852099z",
  fillRule: "nonzero"
}))));
module.exports = exports.default;